import {ToastNotification} from '../../models/notification-payload';
import {PushNotificationSettings} from '../../models/signalr-query-result.interface';
import {EventAlert} from '../../models/events/event-interface';

export class ToggleAppTheme {
  static readonly type = '[Shared] Toggle App Theme';

  constructor(public paylaod: boolean) {
  }
}

export class ToggleSidebar {
  static readonly type = '[Shared] ToggleSidebar';
}

export class LoginSuccess {
  static readonly type = '[Shared] Login Success';

  constructor(public paylaod: string) {
  }
}

export class SetNotificationsSettings {
  static readonly type = '[Shared] Set Notifications Settings';

  constructor(public paylaod: PushNotificationSettings) {
  }
}
export class GetServerConnectionStatus {
  static readonly type = '[Shared] Get Server Connection Status';
}

export class AddToastMessage {
  static readonly type = '[Shared] Add Toast Notification';

  constructor(public paylaod: ToastNotification) {
  }
}

export class GetLanguages{
  static readonly type = '[Shared] Get language settings';
}
export class NewAlert {
  static type = '[Shared] Show Alert';

  constructor(public newAlert: EventAlert) {
  }
}
